module.exports = __webpack_public_path__ + "static/Brandmint-b14bc7a2479a00f3c494fb1e0f4d4c27.png";